import { KeyOutlined, LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import { Spin, message } from 'antd';
import type { MenuProps } from 'antd';
import { createStyles } from 'antd-style';
import { stringify } from 'querystring';
import React, { useState } from 'react';
import { flushSync } from 'react-dom';
import HeaderDropdown from '../HeaderDropdown';
import { REMOVE_Division, REMOVE_EXP, REMOVE_REFRESHTOKEN, REMOVE_TOKEN } from '@/utils/token';
import { ModalForm, ProFormDependency, ProFormText } from '@ant-design/pro-components';
import { postUserEditMyPwd } from '@/services/operation-api/user';

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { initialState } = useModel('@@initialState');
  return <span className="anticon">{"客服(退出)"}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, children }) => {
  const [isPasswordModalOpen, handlePasswordModalOpen] = useState<boolean>(false);


  //修改密码
  const handleEditPassword = async (fields: API.EditMyPwdParm) => {
    const hide = message.loading('正在修改...');
    try {
      hide();
      await postUserEditMyPwd(fields);
      message.success('密码已修改，请重新登录！');
      return true;
    } catch (error) {
      hide();
      message.error('修改失败！');
      return false;
    }
  };
  /**
   * 退出登录，并且将当前的 url 保存
   */
  const loginOut = async () => {
    REMOVE_Division()
    REMOVE_REFRESHTOKEN()
    REMOVE_TOKEN()
    REMOVE_EXP()
    history.push('/login');
  };
  const { styles } = useStyles();

  const { initialState, setInitialState } = useModel('@@initialState');

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    if (key === 'logout') {
      flushSync(() => {
        setInitialState((s) => ({ ...s, currentUser: undefined }));
      });
      loginOut();
      return;
    } else if (key === 'editPwd') {
      handlePasswordModalOpen(true);
      return;
    }
  };

  // const loading = (
  //   <span className={styles.action}>
  //     <Spin
  //       size="small"
  //       style={{
  //         marginLeft: 8,
  //         marginRight: 8,
  //       }}
  //     />
  //   </span>
  // );

  // if (!initialState) {
  //   return loading;
  // }

  // const { currentUser } = initialState;

  // if (!currentUser || !currentUser.name) {
  //   return loading;
  // }

  const menuItems = [
    ...(menu
      ? [
        {
          key: 'center',
          icon: <UserOutlined />,
          label: '个人中心',
        },
        {
          key: 'settings',
          icon: <SettingOutlined />,
          label: '个人设置',
        },
        {
          type: 'divider' as const,
        },
      ]
      : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
    {
      key: 'editPwd',
      icon: <KeyOutlined />,
      label: '修改密码',
    },
  ];

  return (
    <>
      <HeaderDropdown
        menu={{
          selectedKeys: [],
          onClick: onMenuClick,
          items: menuItems,
        }}
      >
        {children}
      </HeaderDropdown>
      {/* 修改密码 */}
      <ModalForm
        width={400}
        title="修改密码"
        modalProps={{
          destroyOnClose: true,
          onCancel: () => {
            handlePasswordModalOpen(false);
          },
          style: { top: '5vh' },
          styles: { body: { maxHeight: '70vh', overflowY: 'auto' } },
        }}
        open={isPasswordModalOpen}
        onOpenChange={handlePasswordModalOpen}
        onFinish={async (value) => {
          const success = await handleEditPassword(value as API.EditMyPwdParm);
          if (success) {
            handlePasswordModalOpen(false);
            setTimeout(() => {
              loginOut();
            }, 1000);
          }
        }}
      >
        <ProFormText.Password
          rules={[
            { required: true, message: '请输入密码' },
            { min: 8, message: '至少8位' },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/,
              message: '密码需要包含大小写字母和数字,至少8位'
            },
          ]}
          width="md"
          name="password"
          label="密码"
        />
        <ProFormDependency name={['password']}>
          {({ password }) => (
            <ProFormText.Password
              label="确认密码"
              name="confirmPassword"
              width="md"
              dependencies={['password']}
              rules={[
                { required: true, message: '请再次输入密码' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次输入的密码不一致'));
                  },
                }),
              ]}
            />
          )}
        </ProFormDependency>
      </ModalForm>

    </>
  );
};
